import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles(() => ({
    containerListCard: {
        display: 'flex',
        flexWrap: 'wrap',
        userSelect: 'none',
        '-webkit-user-select': 'none',
    }
}));
